<template>
  <v-btn
    color="primary"
    class="font-weight-medium subheading upload-button"
    x-large
    outlined
    v-on="on"
    @click="evt => $emit('click', evt)"
  >
    <app-icon left size="25" color="mediumTwo">cloud_upload</app-icon>
    <slot></slot>
  </v-btn>
</template>

<script>
export default {
  props: {
    on: { type: Object, default: null },
    small: { type: Boolean, default: false }
  }
}
</script>

<style lang="scss" scoped>
.upload-button {
  text-transform: none;
  border: none;
}
</style>
